import {action, observable} from 'mobx';

import {BrowseCourse} from '@udemy/browse-course';
import {
    DiscoveryItemImpressionEvent,
    attachFrontendTrackingIds,
} from '@udemy/browse-event-tracking';
import {DiscoveryAPI, AvailableFiltersUnit} from '@udemy/discovery-api';
import {UDData} from '@udemy/ud-data';

export interface CardContainerUnit extends AvailableFiltersUnit<BrowseCourse> {
    items: BrowseCourse[];
}

export class CardContainerStore {
    pageType: string;
    @observable unit: CardContainerUnit;
    @observable loading = false;
    @observable error: Error | null = null;
    backendSource = DiscoveryItemImpressionEvent.backendSourceOptions.DISCOVERY;
    discoveryAPI: DiscoveryAPI;

    constructor(pageType: string, unit: CardContainerUnit, globalOverrides?: UDData) {
        this.pageType = pageType;
        this.unit = unit;
        attachFrontendTrackingIds(this.unit.items);
        this.discoveryAPI = new DiscoveryAPI({}, globalOverrides as UDData);
    }

    @action
    async fetchUnit(options: {pageSize: number}) {
        if (this.loading) {
            return;
        }
        this.loading = true;
        try {
            const response = await this.discoveryAPI.loadItemsForUnit(
                this.unit,
                this.pageType,
                options,
            );
            this.receiveUnit(response.unit as {items: BrowseCourse[]});
        } catch (e) {
            this.receiveError(e as Error);
        }
    }

    @action
    receiveUnit(unit: {items: BrowseCourse[]}) {
        this.loading = false;
        this.unit.items = this.unit.items.concat(unit.items);
        attachFrontendTrackingIds(this.unit.items);
    }

    @action
    receiveError(error: Error) {
        this.loading = false;
        this.error = error;
    }
}
